import { FilterOutlined } from "@ant-design/icons";
import { Badge, Button, Popover } from "antd";
import Overflow from "rc-overflow";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const SEARCH_FIX = [
  "[&_.ant-input-search]:!overflow-hidden",
  "[&_.ant-input-group-addon]:!left-0",
  "[&_.ant-input-group-addon]:!border-l [&_.ant-input-group-addon]:!border-solid [&_.ant-input-group-addon]:!border-l-[#d9d9d9]",
  "[&_.ant-input-search-button]:!border-none [&_.ant-input-search-button]:!shadow-none [&_.ant-input-search-button]:!rounded-none",
].join(" ");

const FilterBar = ({ items = [] }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const data = items.map((node, index) => ({ node, key: `filter-block-${index}` }));

  useEffect(() => {
    setOpen(false);
  }, [items.length]);

  return (
    <Overflow
      className={`flex items-center w-full ${SEARCH_FIX}`}
      data={data}
      itemKey="key"
      maxCount="responsive"
      renderItem={(item) => <div className="inline-flex items-center pr-2 max-w-full">{item.node}</div>}
      renderRest={(omittedItems) => (
        <Popover
          open={open && omittedItems.length > 0}
          onOpenChange={setOpen}
          trigger="click"
          placement="bottomRight"
          arrow={false}
          overlayClassName="filter-bar-popover"
          content={
            <div
              className={`flex flex-col gap-2 w-[88vw] max-w-[280px] max-h-[70vh] overflow-y-auto overflow-x-hidden
                [&>div>*]:!w-full
                [&>div>.ant-btn]:!flex [&>div>.ant-btn]:!items-center [&>div>.ant-btn]:!justify-start [&>div>.ant-btn]:!border-none [&>div>.ant-btn]:!shadow-none [&>div>.ant-btn]:!p-0 [&>div>.ant-btn]:!h-auto
                [&>div>.ant-btn:hover]:!bg-transparent [&>div>.ant-btn:hover]:!text-inherit [&>div>.ant-btn:focus]:!bg-transparent [&>div>.ant-btn:focus]:!text-inherit
                [&_.ant-btn>div]:!w-full [&_.ant-btn>div]:!items-center
                [&_.ant-btn>div>span]:!shrink-0 [&_.ant-btn>div>span]:!w-[120px] [&_.ant-btn>div>span]:!truncate [&_.ant-btn>div>span]:!text-left
                [&_.ant-btn_.ant-select]:!flex-1 [&_.ant-btn_.ant-select]:!min-w-0
                [&_.ant-btn_.ant-select-selector]:!min-h-[32px] [&_.ant-btn_.ant-select-selector]:!flex [&_.ant-btn_.ant-select-selector]:!items-center
                [&_.ant-picker]:!border [&_.ant-picker]:!border-solid [&_.ant-picker]:!border-[#d9d9d9]
                [&>div>.ant-select_.ant-select-selector]:!border [&>div>.ant-select_.ant-select-selector]:!border-solid [&>div>.ant-select_.ant-select-selector]:!border-[#d9d9d9]
                [&_.ant-input-search]:!border [&_.ant-input-search]:!border-solid [&_.ant-input-search]:!border-[#d9d9d9] [&_.ant-input-search]:!rounded-md
                ${SEARCH_FIX}`}
            >
              {omittedItems.map((item) => (
                <div key={item.key} className="w-full min-w-0">
                  {item.node}
                </div>
              ))}
            </div>
          }
        >
          <Button className="bg-white border-none flex items-center gap-1.5">
            <FilterOutlined />
            <span>{t("Filters")}</span>
            <Badge count={omittedItems.length} size="small" style={{ backgroundColor: "#5e72e4" }} />
          </Button>
        </Popover>
      )}
    />
  );
};

export default FilterBar;
